import { useMemo } from 'react';
import { useGetMyPendingPlayRequestsQuery } from 'types/generated/client';
import { useViewer } from 'hooks/useViewer';

/** Availability ids the viewer already has a PENDING request on (shares the "requests remaining" query). */
export function useMyRequestedAvailabilityIds() {
  const { userId } = useViewer();

  const { data } = useGetMyPendingPlayRequestsQuery({
    variables: { userId: userId ?? '' },
    skip: !userId,
    fetchPolicy: 'cache-and-network',
  });

  return useMemo(
    () =>
      new Set(
        (data?.playRequests ?? []).flatMap((row) =>
          row.availabilityId ? [row.availabilityId] : [],
        ),
      ),
    [data],
  );
}
